import { render } from "./RedCross.vue?vue&type=template&id=2f5f1b56"
import script from "./RedCross.vue?vue&type=script&lang=js"
export * from "./RedCross.vue?vue&type=script&lang=js"

import exportComponent from "/builds/rclass/new_shlepakov/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__